import { render, staticRenderFns } from "./AdminApproval.vue?vue&type=template&id=05372c38"
import script from "./AdminApproval.vue?vue&type=script&lang=js"
export * from "./AdminApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports